import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { Form, FormGroup, Input, Label, Container } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import {
  CompanyName,
  DepartmentName,
  Departments,
} from "../../../../../Utils/Constants";
import axios from "axios";
import { baseUrl } from "../../../../../Utils/Baseurl/Baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import "./Department.css";
import { debounce } from "lodash";
interface DepartmentFormProps {
  closeModal: () => void;
}

export default function DepartmentForm({ closeModal }: DepartmentFormProps) {
  const [formData, setFormData] = useState({
    companyId: null as { value: string; label: string } | null,
    departmentname: "",
  });

  const [companies, setCompanies] = useState<
    { value: string; label: string }[]
  >([]);
  const [departmentSuggestions, setDepartmentSuggestions] = useState<string[]>(
    []
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}companydetails/getAllCompany`
        );
        if (response.status === 200 && response.data.data.length > 0) {
          const formattedCompanies = response.data.data.map(
            (company: { id: string; companyname: string }) => ({
              value: company.id,
              label: company.companyname,
            })
          );
          setCompanies(formattedCompanies);
        } else {
          toast.error("No companies found.");
        }
      } catch (error) {
        toast.error("Error fetching companies.");
      }
    };
    fetchCompanies();
  }, []);

  const fetchSuggestions = async (query: string) => {
    if (query.length > 1) {
   
      try {
        const response = await axios.get(`${baseUrl}department/searchDepartment`, {
          params: { query },
        });
  
        if (response.status === 200) {
          setDepartmentSuggestions(response.data.departments || []);
        }
      } catch (error) {
        setDepartmentSuggestions([]);
      }
    
    } else {
      setDepartmentSuggestions([]); // Clear suggestions if input is cleared
    }
  };
  
  // Debounce the function to prevent frequent re-renders
  const debouncedFetchSuggestions = debounce(fetchSuggestions, 300);
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      departmentname: value,
    }));
  
    debouncedFetchSuggestions(value);
  };

  // const handleInputChange = async (e: ChangeEvent<HTMLInputElement>) => {
  //   const { value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     departmentname: value,
  //   }));

  //   if (value.length > 1) {
  //     setIsLoading(true);
  //     try {
  //       const response = await axios.get(
  //         `${baseUrl}department/searchDepartment`,
  //         {
  //           params: { query: value },
  //         }
  //       );

  //       if (response.status === 200) {
  //         setDepartmentSuggestions(response.data.departments || []);
  //       }
  //     } catch (error) {
  //       setDepartmentSuggestions([]);
  //     }
  //     setIsLoading(false);
  //   } else {
  //     setDepartmentSuggestions([]); // Clear suggestions if input is cleared
  //   }
  // };

  const handleSelectChange = (
    selectedOption: { value: string; label: string } | null
  ) => {
    setFormData((prevData) => ({
      ...prevData,
      companyId: selectedOption,
    }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!formData.departmentname.trim()) {
      toast.error("Please enter a division name.");
      return;
    }

    try {
      const response = await axios.post(
        `${baseUrl}department/createdepartment`,
        {
          departmentname: formData.departmentname,
        }
      );

      if (response.status === 201) {
        toast.success("Division created successfully!");
        setFormData((prevData) => ({
          ...prevData,
          departmentname: "",
        }));
        closeModal();
      } else {
        toast.error(response.data.message || "Error creating division.");
      }
    } catch (error) {
      toast.error("Error creating division.");
    }
  };

  return (
    <Container
      fluid
      className="d-flex flex-column align-items-center justify-content-center min-vh-50"
    >
      <div className="login-main w-100 p-3" style={{ maxWidth: "500px" }}>
        <Form className="theme-form" onSubmit={handleSubmit}>
          {/* Department Name Input */}
          <FormGroup style={{ position: "relative" }}>
            <Label>
              Division Name <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="text"
              name="departmentname"
              value={formData.departmentname}
              onChange={handleInputChange}
              placeholder="Enter division name"
              required
            />
        
            {departmentSuggestions.length > 0 && (
              <div className="suggestions-container">
                <ul className="suggestions-list">
                  {departmentSuggestions.map((dept, index) => (
                    <li
                      key={index}
                      onClick={() =>
                        setFormData({ ...formData, departmentname: dept })
                      }
                    >
                      {dept}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </FormGroup>

          {/* Submit Button */}
          <FormGroup className="mb-0">
            <Btn color="primary" className="w-100 mt-3">
              {Departments}
            </Btn>
          </FormGroup>
        </Form>
      </div>
    </Container>
  );
}
